export const TEAM_DASHBOARD_VIEW_BY_SPACE = "space";
export const TEAM_DASHBOARD_VIEW_BY_TEAM = "team";

export const TEAM_DASHBOARD_VIEW_BY_DEFAULT = TEAM_DASHBOARD_VIEW_BY_SPACE;

export const TEAM_DASHBOARD_VIEW_BY_OPTIONS = [
    { label: "Space", value: TEAM_DASHBOARD_VIEW_BY_SPACE },
    { label: "Team", value: TEAM_DASHBOARD_VIEW_BY_TEAM },
];

export const TEAM_DASHBOARD_MAX_VISIBLE_ROWS = 7;
export const TEAM_DASHBOARD_MOBILE_MAX_VISIBLE_ROWS = 5;
export const TEAM_DASHBOARD_SPACE_ROW_HEIGHT_PX = 72;
export const TEAM_DASHBOARD_TEAM_ROW_HEIGHT_PX = 56;
export const TEAM_DASHBOARD_PANEL_BODY_MAX_VIEWPORT = "35vh";

export const TEAM_DASHBOARD_TIME_FILTER_NOW = "now";

/**
 * Normalize a stored/requested Team Panel View by value.
 *
 * @param {string|null|undefined} value
 * @returns {typeof TEAM_DASHBOARD_VIEW_BY_SPACE | typeof TEAM_DASHBOARD_VIEW_BY_TEAM}
 */
export function resolveTeamDashboardViewBy(value) {
    return value === TEAM_DASHBOARD_VIEW_BY_TEAM
        ? TEAM_DASHBOARD_VIEW_BY_TEAM
        : TEAM_DASHBOARD_VIEW_BY_SPACE;
}

/**
 * @param {string|null|undefined} value
 * @returns {boolean}
 */
export function isTeamDashboardSpaceView(value) {
    return resolveTeamDashboardViewBy(value) === TEAM_DASHBOARD_VIEW_BY_SPACE;
}

/**
 * @param {string|null|undefined} value
 * @returns {boolean}
 */
export function isTeamDashboardTeamView(value) {
    return resolveTeamDashboardViewBy(value) === TEAM_DASHBOARD_VIEW_BY_TEAM;
}

/**
 * Cap the scrollable body at a row count. Desktop may also cap at half the
 * viewport so the table never grows past 50% of the window.
 *
 * @param {number} rowHeightPx
 * @param {number} [maxVisibleRows]
 * @param {{ capToHalfViewport?: boolean }} [options]
 * @returns {string}
 */
export function teamDashboardPanelBodyMaxHeight(
    rowHeightPx,
    maxVisibleRows = TEAM_DASHBOARD_MAX_VISIBLE_ROWS,
    { capToHalfViewport = false } = {},
) {
    const row_cap = `${maxVisibleRows * rowHeightPx}px`;

    if (!capToHalfViewport) {
        return row_cap;
    }

    return `min(${row_cap}, ${TEAM_DASHBOARD_PANEL_BODY_MAX_VIEWPORT})`;
}

/**
 * Show a selected avatar's space/board share only when View by Space is on a
 * historical time filter and a percent was calculated for that row.
 *
 * @param {{ isSelected: boolean, timeFilter: string|null|undefined, effortPercent: number|null|undefined }} options
 * @returns {boolean}
 */
export function shouldShowSelectedEffortPercent({
    isSelected,
    timeFilter,
    effortPercent,
}) {
    return (
        Boolean(isSelected) &&
        timeFilter !== TEAM_DASHBOARD_TIME_FILTER_NOW &&
        timeFilter != null &&
        timeFilter !== "" &&
        effortPercent != null &&
        Number.isFinite(Number(effortPercent))
    );
}

/**
 * @param {number|null|undefined} effortPercent
 * @returns {string}
 */
export function formatSelectedEffortPercent(effortPercent) {
    return `${Math.round(Number(effortPercent))}%`;
}

/**
 * @param {Record<string, unknown>|null|undefined} userState
 * @returns {typeof TEAM_DASHBOARD_VIEW_BY_SPACE | typeof TEAM_DASHBOARD_VIEW_BY_TEAM}
 */
export function hydrateTeamDashboardViewBy(userState) {
    return resolveTeamDashboardViewBy(userState?.team_dashboard_view_by);
}
